import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { Bind } from 'primeng/bind';
import { Button } from 'primeng/button';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-not-found',
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss',
    imports: [TranslocoDirective, Bind, Button, UpperCasePipe]
})
export class NotFoundComponent {
  @Input() title: string = "";
  @Input() message: string = "";

  constructor(private translocoService: TranslocoService, protected router: Router) {
    this.translocoService.selectTranslate(['api_error.page_not_found_title', 'api_error.page_not_found_message']).subscribe(messages => {
      if (this.title == "")
        this.title = messages[0];

      if (this.message == "")
        this.message = messages[1];
    });
  }
}
